import { FormikErrors } from 'formik';
import { useRouter } from 'next/router';
import React from 'react';

import { FormValues } from '../../types';
import { MODAL_FIELDS, SESSION_STORAGE_KEYS } from '../../constants';
import { SectionOfferStrip } from '../../../../../insurance/types';
import browserUtils from '../../../../../../utils/browser';
import EmbeddedWidget from '../../../../../../components/embedded-widget';
import generateSchema from '../../schema';
import getDestinationFormValuesFromQuery from '../../utils/get-destination-form-values-from-query';
import getTravelWidgetData from '../../data';
import handleSubmit from '../../utils/handle-widget-submit';
import useTravelWidgetContext from '../../hooks/use-travel-widget-context';

type WidgetWrapperProps = {
  isWidgetActive: boolean;
  offer: SectionOfferStrip;
  setIsWidgetActive: (isActive: boolean) => void;
  productOptionValue: string;
};

const WidgetWrapper: React.FC<WidgetWrapperProps> = ({
  isWidgetActive,
  offer,
  setIsWidgetActive,
  productOptionValue,
}) => {
  const { countries, travellerCount, setTravellerCount } = useTravelWidgetContext();
  const router = useRouter();

  return (
    <EmbeddedWidget<FormValues>
      getData={getTravelWidgetData({
        amountOfTravellers: travellerCount,
        countries,
      })}
      handleSubmit={(formValues: FormValues) => {
        handleSubmit(formValues, router);
      }}
      isWidgetActive={isWidgetActive}
      offer={offer}
      getSchema={(widgetErrors: FormikErrors<FormValues>) =>
        generateSchema<FormValues>({
          countries,
          travellerCount,
          widgetErrors,
        })
      }
      setIsWidgetActive={setIsWidgetActive}
      isDestinationPage={!!productOptionValue}
      modalFields={MODAL_FIELDS}
      getCustomParamValues={() =>
        getDestinationFormValuesFromQuery({
          countries,
          destinationLocation: productOptionValue,
          widgetValuesFromQuery: router.query,
        })
      }
      sessionStorageKeys={{
        travellerCount: {
          key: `${SESSION_STORAGE_KEYS.TRAVELLER_COUNT}${productOptionValue ? `-${productOptionValue}` : ''}`,
          setValue: (sessionStorageKey: string) => {
            const { sessionStorage } = browserUtils.getWindow();
            const amountOfTravellers = sessionStorage.getItem(sessionStorageKey);
            setTravellerCount(Number(amountOfTravellers));
          },
          value: travellerCount,
        },
      }}
      title="Get a travel quote"
    />
  );
};

export default WidgetWrapper;
